module.exports = __webpack_public_path__ + "static/img/Aions_Mar_5.52a5474.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Aions_Mar/Aions_Mar_5.png
// module id = facV
// module chunks = 19